/**
 * Initialize Lucide icons across the theme.
 * Replaces <i data-lucide="name"> with SVG after lucide.min.js loads.
 * Re-runs on Shopify theme editor events and dynamic DOM inserts.
 */
(function () {
  var pending = false;

  function paint(root) {
    if (!window.lucide || typeof window.lucide.createIcons !== 'function') return;
    window.lucide.createIcons({
      attrs: {
        class: 'lucide-icon',
        'stroke-width': '2',
        'aria-hidden': 'true',
        focusable: 'false'
      },
      root: root || document
    });
  }

  function schedulePaint() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      paint();
    });
  }

  function init() {
    paint();

    document.addEventListener('shopify:section:load', schedulePaint);
    document.addEventListener('shopify:section:reorder', schedulePaint);
    document.addEventListener('shopify:block:select', schedulePaint);
    document.addEventListener('shopify:block:deselect', schedulePaint);

    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.hasAttribute && node.hasAttribute('data-lucide')) ||
            (node.querySelector && node.querySelector('[data-lucide]'))
          ) {
            schedulePaint();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
